import "./components/style.css";
import { useParams } from "react-router";
import { useDispatch } from "react-redux";
import { dateFormat } from "../../util/Date";
import { useTranslation } from "react-i18next";
import { setAlert } from "../../redux/reducers/alert";
import React, { useEffect, useRef, useState } from "react";
import { BLACK_SEVEN, BLUE_EIGHT, WHITE } from "../../theme";
import logoImg from "../../assets/images/logo-v1.png";
import { getSchoolByIdForPaymentLink } from "../../api/schools";
import backButtonIcon from "../../assets/images/back-button-icon.png";
import {
  Box,
  Button,
  Divider,
  FormControl,
  FormLabel,
  TextField,
  Typography,
} from "@material-ui/core";
import {
  createTransactionForPayment,
  fetchPayeeData,
  initiateTransactionForPayment,
} from "../../api/student";

export default function PaymentDashboard() {
  const { schoolId } = useParams();
  const [student, setStudent] = useState({});
  const [payeeId, setPayeeId] = useState(null);
  const [isPayeeId, setIsPayeeId] = useState(false);
  const [schoolName, setSchoolName] = useState(null);
  const [payeeType, setPayeeType] = useState(null);
  const [studentId, setStudentId] = useState("");
  const [payAmount, setPayAmount] = useState(null);
  const [customAmount, setCustomAmount] = useState(null);
  const [cbdUrl, setCbdUrl] = useState("cbd");
  const [clientCode, setClientCode] = useState("cbd");
  const [hiddenXml, setHiddenXML] = useState("xml");
  const submitForm = useRef(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  if (schoolId) {
    localStorage.setItem("schoolId", schoolId);
  }

  const amount = (e) => {
    const format = new Intl.NumberFormat("en-US").format(e);
    if (format.indexOf(".") > 0) {
      return format.substr(0, format.indexOf("."));
    } else {
      return new Intl.NumberFormat("en-US").format(e);
    }
  };

  const showErrorAlert = (message) => {
    if (!message) message = "Something went wrong";
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };

  const showSuccessAlert = (message) => {
    dispatch(
      setAlert({
        severity: "success",
        message,
        show: true,
      })
    );
  };

  const handlePayeeIdData = async () => {
    if (!payeeId) {
      payeeType &&
        payeeType.toLowerCase() === "parent"
        ? showErrorAlert("Enter School Family Account Number")
        : showErrorAlert("Please enter payee ID");

      setIsPayeeId(false);
    } else {
      setIsPayeeId(false);
      const response = await fetchPayeeData(payeeId, payeeType, schoolId);
      if (response?.status) {
        setStudent(response?.data);
        setStudentId(response?.data?.id);
        setPayAmount(response?.data?.total_balance_amount);
        setIsPayeeId(true);
        showSuccessAlert("Data fetched successfully");
      } else {
        showErrorAlert("Something went wrong");
        setIsPayeeId(false);
      }
    }
  };

  const handleCreateTransaction = async () => {
    if (!customAmount?.length && payAmount <= 0) {
      showErrorAlert("Please enter amount greater than zero");
    } else if (customAmount?.length && customAmount < 1) {
      showErrorAlert("Please enter amount greater than zero");
    } else {
      const payload = {
        schoolId,
        studentId,
        amount: customAmount ? customAmount : payAmount,
      };

      const response = await createTransactionForPayment(payload);
      if (response?.status) {
        if (response?.transaction) {
          await handleInitiateTransaction(response?.transaction?.orderId);
        }
      } else {
        showErrorAlert("Something went wrong");
      }
    }
  };

  const handleInitiateTransaction = async (orderId) => {
    const amount = customAmount ? customAmount : payAmount;
    const response = await initiateTransactionForPayment(
      orderId,
      amount,
      schoolId
    );
    if (response?.status) {
      setCbdUrl(response?.cbdUrl);
      setClientCode(response?.clientId);
      setHiddenXML(response?.message);
      submitForm.current.submit();
    } else {
      showErrorAlert("Something went wrong");
    }
  };

  const fetchSchool = async (schoolId) => {
    try {
      const response = await getSchoolByIdForPaymentLink(schoolId);
      if (!response.status) {
        showErrorAlert(
          response?.message || t("text_error_in_fetching_school_detail")
        );
        return;
      }
      setSchoolName(response?.school?.name);
      setPayeeType(response?.school?.payeeType);
    } catch (err) {
      showErrorAlert(err.message || t("text_error_in_fetching_school_detail"));
    }
  };

  useEffect(() => {
    fetchSchool(schoolId);
  }, [schoolId]);

  return (
    <div className="main-conatiner">
      {isPayeeId && (
        <div
          style={{
            backgroundColor: "transparent",
            height: 30,
            width: 30,
            borderRadius: 5,
            cursor: "pointer",
            position: "absolute",
            top: "2%",
            left: "2%",
          }}
          role="presentation"
          onClick={() => setIsPayeeId(false)}
        >
          <img
            src={backButtonIcon}
            style={{ width: 60 }}
            alt="back-button-icon"
          />
        </div>
      )}

      <Box className="feeCard">
        <Box width="90%" mx="auto">
          {!isPayeeId && (
            <Box>
              <div
                className="logoImgDiv"
                style={{ maxWidth: "524px", width: "100%", margin: "auto" }}
              >
                <img src={logoImg} />
                <Typography
                  style={{
                    margin: 0,
                    fontSize: "38px",
                    fontWeight: 600,
                    color: `${BLACK_SEVEN}`,
                    margin: "20px 0px",
                    lineHeight: "40px",
                  }}
                >{`Welcome to ${schoolName ?? ""}`}</Typography>
                {payeeType && payeeType.toLowerCase() == "student" && <Typography
                  style={{
                    margin: 0,
                    fontSize: "24px",
                    fontWeight: 600,
                    color: `${BLACK_SEVEN}`,
                    marginTop: 20,
                    marginBottom: 50,
                  }}
                >
                  Please enter your payee ID for school fee payments
                </Typography>}

              </div>

              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                width="100%"
              >
                <FormControl variant="outlined" fullWidth>
                  {payeeType && (
                    <FormLabel>
                      {payeeType.toLowerCase() === "parent"
                        ? "Enter School Family Account Number"
                        : "Enter Payee ID"}
                    </FormLabel>
                  )}

                  <TextField
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    required={true}
                    value={payeeId}
                    onChange={(event) => {
                      setPayeeId(event?.target?.value);
                    }}
                  />
                </FormControl>
                <Button
                  style={{
                    width: "100%",
                    marginTop: 50,
                    marginBottom: 10,
                    backgroundColor: BLUE_EIGHT,
                    color: WHITE,
                    borderRadius: 10,
                    textTransform: "capitalize",
                    fontSize: 18,
                    minHeight: 50,
                  }}
                  variant="contained"
                  onClick={handlePayeeIdData}
                >
                  Next
                </Button>
              </Box>
            </Box>
          )}

          {isPayeeId && payeeType.toLowerCase() === "student" && (
            <>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                width="100%"
              >
                <div className="logoImgDiv2">
                  <img src={logoImg} />
                  <Typography
                    style={{
                      margin: 0,
                      fontSize: "24px",
                      color: `${BLACK_SEVEN}`,
                      marginBottom: 20,
                    }}
                  >{`Welcome to ${schoolName}`}</Typography>
                </div>

                <FormControl variant="outlined" fullWidth>
                  <FormLabel>{t("text_payee_id")}</FormLabel>

                  <TextField
                    variant="outlined"
                    disabled={true}
                    value={payeeId}
                  />
                </FormControl>
              </Box>

              <Box
                display="flex"
                flexDirection="column"
                style={{
                  backgroundColor: WHITE,
                  borderRadius: "33px",
                  padding: "25px",
                  border: `1px solid ${BLUE_EIGHT}`,
                  marginTop: "20px",
                }}
              >
                <div className="fee-details">
                  <div className="fee-details-row">
                    <div className="fee-text-one">School Name</div>
                    <div className="fee-text-two">
                      {student?.school?.name ?? "-"}
                    </div>
                  </div>
                  <div className="fee-details-row">
                    <div className="fee-text-one">Student ID</div>
                    <div className="fee-text-two">
                      {student?.payeeId ?? "-"}
                    </div>
                  </div>
                  <div className="fee-details-row">
                    <div className="fee-text-one">Student Name</div>

                    <div className="fee-text-two">
                      {student?.firstName} {student?.lastName}{" "}
                    </div>
                  </div>
                  {/* <Divider style={{ margin: "20px 0px" }} /> */}
                  <div className="fee-details-row">
                    <div className="fee-text-one">Payment Date</div>
                    <div className="fee-text-two">
                      {dateFormat(student?.dueDate) ?? "N/A"}
                    </div>
                  </div>
                  <div className="fee-details-row">
                    <div className="fee-text-one">Amount Due</div>
                    <div className="fee-text-two">AED {amount(payAmount)}</div>
                  </div>
                  <Divider style={{ margin: "20px 0px" }} />
                </div>
                <div className="fee-total-amountdiv">
                  <div className="fee-total-amount">
                    <div className="fee-total-amount-head">Total Amount</div>
                    <div className="fee-total-amount-value">
                      AED {amount(payAmount)}
                    </div>
                  </div>

                  <TextField
                    placeholder="Enter The Amount You Wish To Pay"
                    label="Enter Amount"
                    type="number"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "100%" }}
                    value={customAmount}
                    onChange={(event) => {
                      setCustomAmount(event?.target?.value);
                    }}
                  />
                </div>
              </Box>
              <div className="fee-pay-butdiv">
                <button
                  style={{
                    backgroundColor: BLUE_EIGHT,
                    borderRadius: 15,
                    fontSize: 18,
                    minHeight: 50,
                  }}
                  className="fee-pay-button"
                  onClick={handleCreateTransaction}
                >
                  Pay
                </button>

                <form
                  ref={submitForm}
                  name="redirect"
                  action={cbdUrl}
                  method="POST"
                >
                  <input type="hidden" name="c" value={hiddenXml} />
                  <input type="hidden" name="clientCode" value={clientCode} />

                  <input
                    type="submit"
                    id="btnSubmit"
                    value="Please wait"
                    hidden
                  />
                </form>
              </div>
            </>
          )}

          {isPayeeId && payeeType.toLowerCase() == "parent" && (
            <>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                width="100%"
              >
                <div className="logoImgDiv2">
                  <img src={logoImg} />
                  <Typography
                    style={{
                      margin: 0,
                      fontSize: "24px",
                      color: `${BLACK_SEVEN}`,
                      marginBottom: 20,
                    }}
                  >{`Welcome to ${schoolName}`}</Typography>
                </div>

                <FormControl variant="outlined" fullWidth>
                  <FormLabel>Family Account Number</FormLabel>

                  <TextField
                    variant="outlined"
                    disabled={true}
                    value={payeeId}
                  />
                </FormControl>
              </Box>

              <Box
                display="flex"
                flexDirection="column"
                style={{
                  backgroundColor: WHITE,
                  borderRadius: "33px",
                  padding: "25px",
                  border: `1px solid ${BLUE_EIGHT}`,
                  marginTop: "20px",
                }}
              >
                <div className="fee-details">
                  <div className="fee-details-row">
                    <div className="fee-text-one">School Name</div>
                    <div className="fee-text-two">
                      {student?.school?.name ?? "-"}
                    </div>
                  </div>
                  <div className="fee-details-row">
                    <div className="fee-text-one">Family Account Number</div>
                    <div className="fee-text-two">
                      {student?.payeeId ?? "-"}
                    </div>
                  </div>
                  <div className="fee-details-row">
                    <div className="fee-text-one">Parent Name</div>

                    <div className="fee-text-two">
                      {student?.firstName} {student?.lastName}{" "}
                    </div>
                  </div>
                  <Divider style={{ margin: "20px 0px" }} />
                </div>
                <div className="fee-total-amountdiv">
                  <TextField
                    placeholder="Enter The Amount You Wish To Pay"
                    label="Enter Amount"
                    type="number"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    style={{ width: "100%" }}
                    value={customAmount}
                    onChange={(event) => {
                      setCustomAmount(event?.target?.value);
                    }}
                  />
                </div>
              </Box>
              <div className="fee-pay-butdiv">
                <button
                  style={{
                    backgroundColor: BLUE_EIGHT,
                    borderRadius: 15,
                    fontSize: 18,
                    minHeight: 50,
                  }}
                  className="fee-pay-button"
                  onClick={handleCreateTransaction}
                >
                  Pay
                </button>

                <form
                  ref={submitForm}
                  name="redirect"
                  action={cbdUrl}
                  method="POST"
                >
                  <input type="hidden" name="c" value={hiddenXml} />
                  <input type="hidden" name="clientCode" value={clientCode} />

                  <input
                    type="submit"
                    id="btnSubmit"
                    value="Please wait"
                    hidden
                  />
                </form>
              </div>
            </>
          )}

        </Box>
      </Box>
    </div>
  );
}
